/**
 * จู๋หมิง 竹鳴灣 (อ่าวไผ่ขาน) as a zone: the 1 km starter region (data/regions/zhuming.ts, docs/design/OW_1KM.md) with the
 * village of layout ข (data/layouts/yanyu.ts, 160 m, real size) stamped at its core. Off the world grid (in `ZONES`, not
 * `ZONE_LIST`): no warps lead in or out yet. The client plays it with `?map=zhuming` (render3d2/koMap.ts).
 */
import type { ZoneDef } from '../zones';

export const ZHUMING_ZONE_ID = 'zhuming' as const;

/** Player-facing names: Thai, the Han name (UI_GLYPHS) and its meaning. */
export const ZHUMING_NAME = { th: 'จู๋หมิง', han: '竹鳴灣', meaning: 'อ่าวไผ่ขาน' } as const;

export const ZHUMING_ZONE: ZoneDef = {
  id: ZHUMING_ZONE_ID,
  at: [70, 70],
  name: ZHUMING_NAME.th,
  kind: 'village',
  terrain: 'plains',
  // The region's side (with region maps off the layout's 160 m map is played).
  size: 1024,
  seed: 309,
  layout: 'yanyu',
  region: 'zhuming',
  offGrid: true,
  tint: [1.02, 1.03, 0.98],
  music: 'yanyu',
  wildMusic: 'wilds',
  levels: 'ระดับ 1–5',
  // The village's own grounds (layout ข's regions); the region's wilds add the open country's (systems/activity.ts).
  spawns: [
    { monster: 'wolf', region: 'wolves', n: 12 },
    { monster: 'bandit', region: 'bandits', n: 10 },
    { monster: 'sparrer', region: 'west', n: 4 },
  ],
};
